<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconAudioTransmission_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="m11.614 10.318-.705-.704q.5-.466.784-1.103a3.3 3.3 0 0 0 .284-1.352q0-.716-.284-1.34a3.4 3.4 0 0 0-.784-1.092L11.614 4q.636.603 1.011 1.42.375.818.375 1.74 0 .92-.375 1.738a4.5 4.5 0 0 1-1.011 1.42m-1.455-1.454-.727-.728q.204-.192.33-.437.124-.245.124-.54t-.125-.54a1.6 1.6 0 0 0-.33-.437l.728-.727q.364.33.568.767.205.437.205.937t-.205.938a2.4 2.4 0 0 1-.568.767m-3.523.113q-.75 0-1.284-.534a1.75 1.75 0 0 1-.534-1.284q0-.75.534-1.284a1.75 1.75 0 0 1 1.284-.534q.75 0 1.284.534.535.534.535 1.284T7.92 8.443a1.75 1.75 0 0 1-1.284.534M3 12.614V11.34q0-.375.193-.705a1.26 1.26 0 0 1 .534-.5 7 7 0 0 1 1.307-.5 6 6 0 0 1 1.602-.204q.876 0 1.603.204.727.205 1.306.5.342.17.534.5.195.33.194.705v1.273z"
    />
</svg>
